<template>
  <div class="home-page">
    <Nav />

    <main class="page-main">
      <section id="hero" class="hero-section">
        <div class="hero-bg">
          <img class="hero-bg-image" :src="heroBannerUrl" alt="首页横幅" @error="handleHeroBannerError" />
          <div class="hero-container">
            <div class="hero-copy">
              <h1 class="hero-title" v-html="heroTitleHtml"></h1>
              <p class="hero-desc">{{ heroSubtitle }}</p>
              <button type="button" class="hero-btn" @click="openExperienceDialog">立即体验</button>
            </div>
          </div>
        </div>
      </section>

      <section id="intro" class="section intro-section">
		<div class="section-title-wrap">
		  <div class="section-title-row">
		    <img class="title-decor left" src="../../assets/img/zs1.png" alt="" />
		    <h2 class="section-title">平台介绍</h2>
		    <img class="title-decor right" src="../../assets/img/zs2.png" alt="" />
		  </div>
		  <p class="section-subtitle">构建主播孵化可复制的服务模型，为行业各方提供标准化支持</p>
		</div>
        <div class="intro-cards container-1290" @mouseleave="hoverIntroIndex = null">
          <article
            v-for="(item, index) in introList"
            :key="item.title"
            :class="['intro-card', { active: isIntroActive(index) }]"
            @mouseenter="hoverIntroIndex = index"
          >
            <img class="intro-icon" :src="isIntroActive(index) ? item.iconxz : item.icon" :alt="item.title" />
            <h3>{{ item.title }}</h3>
            <p v-html="item.desc"></p>
          </article>
        </div>
      </section>
	  
	  

      <section id="recommend" class="section recommend-section">
        <div :class="['recommend-shell', recommendShellClass]">
          <div class="section-title-wrap">
            <div class="section-title-row">
              <img class="title-decor left" :src="titleDecor" alt="" />
              <h2 class="section-title">重点推荐</h2>
              <img class="title-decor right" :src="titleDecor" alt="" />
            </div>
          </div>

          <div class="recommend-panel container-1290">
            <button type="button" class="recommend-mode" @click="toggleRecommendMode">
              <img src="../../assets/img/4icon.png">
              <span>{{ recommendMode === 'anchor' ? '主播推荐' : '任务推荐' }}</span>
            </button>

            <div class="recommend-tip2">
              {{ recommendMode === 'anchor' ? '平台认证优质主播，信誉有保障，合作更放心' : '精选优质商业合作任务，助力主播实现商业价值' }}
            </div>

            <div class="recommend-viewport">
              <transition name="recommend-fade" mode="out-in">
                <div v-if="recommendMode === 'anchor'" key="anchor" class="recommend-list-track">
                  <article v-for="(item, index) in recommendPreviewList" :key="item.id || item.name + '-' + index" class="anchor-item">
                    <div class="anchor-image-wrap">
                      <img class="anchor-image" :src="item.image" :alt="item.name" />
                    </div>
                    <div class="anchor-info">
                      <div class="anchor-name">{{ item.name }}</div>
                      <div class="anchor-tag" :class="'tag'+index">{{ item.tag }}</div>
                      <div class="anchor-meta">
                        <div class="anchor-num">粉丝 <span>{{ item.left }}</span></div>
                         <div class="anchor-num">带货量 <span>{{ item.right }}</span></div>
                      </div>
                    </div>
                  </article>
                </div>

                <div v-else key="task" class="task-list-track">
                  <article v-for="(item, index) in taskList" :key="item.id || item.title + '-' + index" class="task-item">
                    <div class="task-item-top">
                      <div class="task-tag">{{ item.tag }}</div>
                      <img class="task-corner" :src="taskCornerIcon" alt="任务" />
                    </div>
                    <div class="task-title">{{ item.title }}</div>
                    <div class="task-price">{{ item.price }}</div>
                    <div class="task-desc">{{ item.desc }}</div>
                  </article>
                </div>
              </transition>
            </div>

            <div class="recommend-expand-row container-1290" :class="recommendMode">
              <button type="button" class="recommend-expand" @click="toggleRecommendMode">
                <img :src="recommendMode === 'anchor' ? tabIconActive : tabIconInactive" alt="展开" />
                <span>{{ recommendMode === 'anchor' ? '点击展开' : '点击返回' }}</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section id="support" class="section support-section">
		<div class="section-title-wrap">
		  <div class="section-title-row">
		    <img class="title-decor left" src="../../assets/img/zs1.png" alt="" />
		    <h2 class="section-title">扶持政策</h2>
		    <img class="title-decor right" src="../../assets/img/zs2.png" alt="" />
		  </div>
		  <p class="section-subtitle">平台推出多项扶持计划，全方位助力主播成长与发展</p>
		</div>
        <div class="support-grid">
          <article class="support-large">
            <img class="support-large-image" :src="supportMain.image" :alt="supportMain.title" />
            <div class="support-large-body">
              <h3>{{ supportMain.title }}</h3>
              <p>{{ supportMain.desc }}</p>
            </div>
          </article>

          <div class="support-right">
            <article v-if="supportSide[0]" class="support-small">
              <img class="support-small-image2" :src="supportSide[0].image" :alt="supportSide[0].title" />
              <div class="support-small-body">
                <h3>{{ supportSide[0].title }}</h3>
                <p>{{ supportSide[0].desc }}</p>
              </div>
            </article>

            <article v-if="supportSide[1]" class="support-small">
              <img class="support-small-image2" :src="supportSide[1].image" :alt="supportSide[1].title" />
              <div class="support-small-body">
                <h3>{{ supportSide[1].title }}</h3>
                <p>{{ supportSide[1].desc }}</p>
              </div>
            </article>

            <article v-if="supportSide[2]" class="support-small support-small-wide">
              <img class="support-small-image" :src="supportSide[2].image" :alt="supportSide[2].title" />
              <div class="support-small-body">
                <h3>{{ supportSide[2].title }}</h3>
                <p>{{ supportSide[2].desc }}</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section id="finance" class="section finance-section">
		<div class="section-title-wrap">
		  <div class="section-title-row">
		    <img class="title-decor left" src="../../assets/img/zs1.png" alt="" />
		    <h2 class="section-title">金融服务</h2>
		    <img class="title-decor right" src="../../assets/img/zs2.png" alt="" />
		  </div>
		  <p class="section-subtitle">COG投融资计划，为优质主播和MCN机构提供发展资金支持</p>
		</div>
        <div class="finance-list ">
          <article class="finance-card left">
            <div class="finance-icon-box">
              <img :src="anchorIconFinance" alt="主播成长扶持计划" />
            </div>
            <h3>主播成长扶持计划</h3>
            <p>面向高潜力个人主播，提供50万-500万发展资金，助力内容升级与团队建设</p>
            <div class="finance-actions">
              <div class="small-tag">发展资金</div>
              <div class="small-tag" >50万-500万</div>
            </div>
          </article>

          <article class="finance-center">
            <img :src="financeImage" alt="COG 融资政策合作" />
            <div class="jbtt">COG投融资联合体</div>
            <p>联合多家知名投资机构，为优秀主播及MCN机构提供专属投融资服务通道</p>
          </article>

          <article class="finance-card right">
            <div class="finance-icon-box">
              <img :src="shieldIconFinance" alt="投融资服务支持" />
            </div>
            <h3>投融资服务能力</h3>
            <p>专业FA团队全程服务，涵盖商业计划辅导、估值定价、交易结构设计、投后管理</p>
            <div class="finance-actions">
              <div type="button" class="small-tag" >团队全程服务</div>
            </div>
          </article>
        </div>
      </section>

      <section id="assets" class="section assets-section">
        <div class="assets-bg">
		  <div class="section-title-wrap">
		    <div class="section-title-row">
		      <img class="title-decor left" src="../../assets/img/zs1.png" alt="" />
		      <h2 class="section-title">数字资产服务</h2>
		      <img class="title-decor right" src="../../assets/img/zs2.png" alt="" />
		    </div>
		    <p class="section-subtitle">基于区块链技术，为主播提供可信数字资产管理服务</p>
		  </div>
          <div class="asset-list container-1290">
            <article v-for="(item, index) in assetList" :key="item.title" :class="['asset-item', { active: index === 0 }]">
              <div class="asset-body">
                <img class="asset-icon" :src="item.icon" :alt="item.title" />
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section class="section cta-section">
        <div class="cta-box container-1290">
          <h2>立即开启<span>COG主播孵化扶持之旅</span></h2>
          <p>立即提交申请，我们的专业团队将在1个工作日内与您联系</p>
          <button type="button" class="cta-btn" @click="openApplyDialog">立即申请</button>
        </div>
      </section>
    </main>

    <Footer />

  </div>
</template>

<script>
import Nav from './components/Nav.vue';
import Footer from './components/Footer.vue';
import { getHomepage } from '@/api/user';
import { getToken } from '@/utils/auth';

const DEFAULT_HERO_TITLE = '让每一位<span>主播的价值</span><br />被看见、被信任、被赋能';
const DEFAULT_HERO_SUBTITLE = 'COG主播可信资产平台致力于为主播提供资产评估、数据存证、商业合作及投融资对接一站式服务，构建主播经济可信生态。';
const STREAMER_TYPE_TEXT_MAP = {
  beauty_care: '美妆护肤',
  fashion_apparel: '服饰穿搭',
  food_beverage: '食品饮料',
  digital: '3C数码',
  mother_baby: '母婴亲子',
  home_living: '家居生活',
  maternity_child: '母婴育儿',
  education: '教育知识',
  sports_outdoors: '运动户外',
  gaming: '游戏电竞'
};

export default {
  name: 'Home',
  components: {
    Nav,
    Footer
  },
  computed: {
    recommendShellClass() {
      return this.recommendMode === 'anchor' ? 'anchor-mode' : 'task-mode';
    },
    recommendPreviewList() {
      return this.recommendList;
    }
  },
  data() {
    return {
      hoverIntroIndex: null,
      heroTitleHtml: DEFAULT_HERO_TITLE,
      heroSubtitle: DEFAULT_HERO_SUBTITLE,
      heroBannerUrl: require('../../assets/img/banner1.png'),
      titleDecor: require('../../assets/img/标题装饰.png'),
      arrowIcon: require('../../assets/img/4icon.png'),
      tabIconActive: require('../../assets/img/tjz.png'),
      tabIconInactive: require('../../assets/img/tjy.png'),
      taskCornerIcon: require('../../assets/img/zbicon.png'),
      financeImage: require('../../assets/img/融资联合体.png'),
      anchorIconFinance: require('../../assets/img/主播icon.png'),
      shieldIconFinance: require('../../assets/img/融资icon.png'),
      assetCardBg: require('../../assets/img/矩形底卡.png'),
      recommendMode: 'anchor',
      introList: [
        {
          title: '平台定位',
          desc: '国内领先的主播可信资产评估与服务平台，<br/>构建主播经济信用基础设施',
          iconxz: require('../../assets/img/icon1-选中.png'),
		  icon: require('../../assets/img/icon1.png')
        },
        {
          title: '平台能力',
          desc: '数据存证、资产评估、投融资对接，全方位<br/>赋能主播成长',
          iconxz: require('../../assets/img/2icon-选中.png'),
		  icon: require('../../assets/img/2icon.png')
        },
        {
          title: '服务内容',
          desc: '提供一站式可信服务解决方案<br/>信用基础设施',
          iconxz: require('../../assets/img/3icon-选中.png'),
		  icon: require('../../assets/img/3icon.png')
        }
      ],
      recommendList: [
        {
          name: '张小鱼',
          tag: '颜值主播',
          left: '14.2W',
          right: '12.6万',
          image: require('../../assets/img/avatar.png')
        },
        {
          name: 'Marala',
          tag: '剧情带货',
          left: '9.5W',
          right: '8.02万',
          image: require('../../assets/img/人物3.png')
        },
        {
          name: '美妮',
          tag: '陪伴主播',
          left: '24.7W',
          right: '19.5万',
          image: require('../../assets/img/avatar.png')
        }
      ],
      taskList: [
        {
          tag: '直播',
          title: '粉丝一起云旅游',
          price: '¥ 30,000-40,000 元',
          desc: '旅行类项目直播'
        },
        {
          tag: 'Vlog',
          title: '瓦屋山隐藏玩法',
          price: '¥ 10,000-20,000 元',
          desc: '深度介绍瓦屋山景区'
        },
        {
          tag: '短视频',
          title: '景区推荐官',
          price: '¥ 20,000-30,000 元',
          desc: '三分钟介绍这个景区推荐玩法和当地美食，一小时内配齐3万个商品，促进商品下单成交'
        }
      ],
      supportMain: {
        title: '流量扶持',
        desc: '平台联合主流内容平台，为优质主播提供流量加权、热门推荐位等资源，助力快速涨粉',
        image: require('../../assets/img/image.png')
      },
      supportSide: [
        {
          title: '培训扶持',
          desc: '提供专业直播技巧、内容创作、商业化运营培训课程，由行业资深导师一对一指导',
          image: require('../../assets/img/image2.png')
        },
        {
          title: '商业合作扶持',
          desc: '对接品牌方资源，优先匹配商业合作机会，为认证主播提供优质商单推荐服务',
          image: require('../../assets/img/image3.png')
        },
        {
          title: '品牌孵化扶持',
          desc: '帮助潜力主播打造个人品牌IP，提供品牌策划、包装设计、全媒体推广等全方位服务',
          image: require('../../assets/img/image4.png')
        }
      ],
      assetList: [
        {
          title: '主播可信档案',
          desc: '建立主播全维度可信数字档案，涵盖身份认证、平台数据、合作记录、信用评价等',
          icon: require('../../assets/img/as1.png')
        },
        {
          title: '数据存证',
          desc: '关键业务数据上链存证，确保数据真实不可篡改，为主播价值提供可信证明',
          icon: require('../../assets/img/as2.png')
        },
        {
          title: '资产评估',
          desc: '多维度主播价值评估模型，科学评估主播商业价值，输出权威评估报告',
          icon: require('../../assets/img/as3.png')
        },
        {
          title: '资产管理',
          desc: '提供数字资产全生命周期管理，包括资产登记、流转记录、权益保护等服务',
          icon: require('../../assets/img/as4.png')
        }
      ]
    };
  },
  created() {
    this.fetchHomepageData();
  },
  methods: {
    async fetchHomepageData() {
      try {
        const response = await getHomepage();
        const homepageData = response && response.data ? response.data : {};
        const banners = Array.isArray(homepageData.banners) ? homepageData.banners : [];
        const streamers = Array.isArray(homepageData.streamers) ? homepageData.streamers : [];
        const tasks = Array.isArray(homepageData.tasks) ? homepageData.tasks : [];
        const policies = Array.isArray(homepageData.policies) ? homepageData.policies : [];

        if (banners.length > 0) {
          const banner = banners[0] || {};
          this.heroTitleHtml = banner.title || this.heroTitleHtml;
          this.heroSubtitle = banner.subtitle || this.heroSubtitle;
          this.heroBannerUrl = banner.image_url || this.heroBannerUrl;
        }

        if (streamers.length > 0) {
          this.recommendList = streamers.map((item, index) => ({
            id: item.id,
            name: item.name || '--',
            tag: this.getStreamerTypeText(item.type, item.type_text),
			
            left: item.fans_count || '--',
            right: item.sales_volume || '--',
            image: item.avatar || (this.recommendList[index] && this.recommendList[index].image) || this.recommendList[0].image
          }));
        }

        if (tasks.length > 0) {
          this.taskList = tasks.map(item => ({
            id: item.id,
            tag: item.type_text || this.getTaskTypeText(item.type),
            title: item.name || '--',
            price: item.price || '--',
            desc: item.description || ''
          }));
        }

        if (policies.length > 0) {
          const normalizedPolicies = policies.map((item, index) => ({
            id: item.id,
            title: item.title || '--',
            desc: item.description || '',
            image: item.icon || this.getPolicyFallbackImage(index)
          }));

          this.supportMain = normalizedPolicies[0] || this.supportMain;
          this.supportSide = normalizedPolicies.slice(1, 4);
        }
      } catch (error) {
        console.error('获取首页数据失败', error);
      }
    },
    toggleRecommendMode() {
      this.recommendMode = this.recommendMode === 'anchor' ? 'task' : 'anchor';
    },
    handleHeroBannerError() {
      const fallbackBanner = require('../../assets/img/banner1.png');
      if (this.heroBannerUrl !== fallbackBanner) {
        this.heroBannerUrl = fallbackBanner;
      }
    },
    isIntroActive(index) {
      return this.hoverIntroIndex === null ? index === 0 : this.hoverIntroIndex === index;
    },
    getStreamerTypeText(type, typeText) {
      return typeText || STREAMER_TYPE_TEXT_MAP[type] || '优质主播';
    },
    getTaskTypeText(type) {
      const taskTypeMap = {
        live: '直播',
        vlog: 'Vlog',
        short_video: '短视频'
      };

      return taskTypeMap[type] || '任务';
    },
    getPolicyFallbackImage(index) {
      const images = [
        require('../../assets/img/image.png'),
        require('../../assets/img/image2.png'),
        require('../../assets/img/image3.png'),
        require('../../assets/img/image4.png')
      ];

      return images[index] || images[0];
    },
    getUserCenterPath() {
      let userInfo = {};

      try {
        const rawUserInfo = window.localStorage.getItem('userInfo');
        userInfo = rawUserInfo ? JSON.parse(rawUserInfo) : {};
      } catch (error) {
        userInfo = {};
      }

      const userType = userInfo.type || window.localStorage.getItem('loginType');

      return userType === 'mcn' || userType === 'org' ? '/user/org' : '/user/personal';
    },
    openExperienceDialog() {
      if (!getToken()) {
        this.$router.push('/login');
        return;
      }

      this.$router.push(this.getUserCenterPath());
    },
    openApplyDialog() {
      this.$openApplyDialog({
        source: 'home-cta-apply',
        demandTypes: ['我要资产评估']
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home-page {
  background: #fff;
  color: #1f2448;
}

.page-main {
  overflow: hidden;
}

.container-1290 {
  width: 1290px;
  max-width: calc(100vw - 40px);
  margin: 0 auto;
}

.hero-section {
  // padding-top: 66px;
  display: flex;
      justify-content: center;
}

.hero-bg {
  position: relative;
  width: 100%;
  height: 1080px;
  overflow: hidden;
}

.hero-bg-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

.hero-container {
  position: relative;
  width: 1440px;
  max-width: 100%;
  min-height: 910px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 84px 121px 0;
}

.hero-copy {
  width: 780px;
  position: relative;
  z-index: 2;
}



.hero-title {
  width: 780px;
  font-family: Lenovo-XiaoxinChaokuGB, Lenovo-XiaoxinChaokuGB;
  font-weight: 400;
  font-size: 62px;
  color: #1E293B;
  line-height: 72px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

:deep(.hero-title span) {
    /* 设置渐变背景（从左到右）*/  background: linear-gradient(90deg, #316FEC, #C272ED);  /* 将背景裁剪为文字形状 */  -webkit-background-clip: text;  background-clip: text;  /* 隐藏原始文字颜色（显示渐变色） */  color: transparent;  /* 可选：添加字体样式增强效果 */  font-size: 62px;}

.hero-desc {
  margin-top: 28px;
  width: 465px;
  font-family: sans-serif;
  color: #646199;
  font-size: 20px;
}

.hero-title,
:deep(.hero-title span) {
  font-family: 'Lenovo-XiaoxinChaokuGB', 'Lenovo-XiaoxinChaokuGB-Regular', 'Microsoft YaHei', sans-serif;
}

.hero-btn {
  margin-top: 58px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  width: 161px;
  height: 56px;
  background: linear-gradient( 117deg, #518BFF 0%, #9E5DFF 100%), linear-gradient( 149deg, rgba(172,234,255,0.6) 0%, rgba(209,250,255,0) 100%);
  box-shadow: 0px 4px 14px 0px rgba(99,102,241,0.35);
  cursor: pointer;
  border-radius: 12px 12px 12px 12px;
}

.section {
  margin-top: 86px;
}
	
.intro-section{
	height: 570px;
}
:deep(.section-title-wrap) {
  text-align: center;
}
.support-section{
	background-image: url('../../assets/img/zcbg.png');
	background-size: 100% 100%;
	    height: 710px;
}
:deep(.section-title-row) {
  display: inline-flex;
  align-items: center;
  gap: 18px;
}

:deep(.title-decor) {
  width: 53px;
  height: 45px;
}

:deep(.section-title) {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 700;
  font-size: 42px;
  color: #1E293B;
  line-height: 52px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

:deep(.section-subtitle) {
  margin-top: 20px;
  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 16px;
  color: #8087A4;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.intro-cards {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 80px;
}

.intro-card {
  width: 370px;
  height: 260px;
  text-align: center;
  border-radius: 16px;
  border: 1px solid #e6e8f6;
  background: #fff;
  box-shadow: 0 6px 18px rgba(118, 124, 240, 0.08);
  cursor: pointer;
}

.intro-card.active {
  background: linear-gradient(180deg, #eef6ff 0%, #ffffff 100%);
  border-color: #7c92ff;
}

.intro-icon {
  width: 70px;
  height: 70px;
  margin-top: 40px;
}

.intro-card h3,
.asset-body h3,
.support-large-body h3,
.support-small-body h3,
.finance-card h3,
.finance-center h3 {
  margin-top: 12px;
  font-size: 18px;
  font-weight: 700;
  color: #1E293B;
}

.intro-card p,
.asset-body p,
.support-large-body p,
.support-small-body p,
.finance-card p,
.finance-center p {
  margin-top: 10px;
  font-size: 14px;
  line-height: 22px;
  color: #8087A4;
}

.recommend-section {
  padding-top: 0px;
}

.recommend-shell {
  position: relative;
  padding: 72px 0 28px;
  min-height: 734px;
  overflow: hidden;
  transition: background 0.45s ease, box-shadow 0.45s ease;
}

.recommend-shell.anchor-mode {
  background: linear-gradient( 320deg, #F0E5FF 0%, #D4CCFF 100%);
}

.recommend-shell.task-mode {
  background: linear-gradient( 333deg, #A1B7FF 0%, #B7DAFF 100%);
}

.recommend-shell::after {
  content: '';
  position: absolute;
  right: -72px;
  top: 0;
  width: 324px;
  height: 100%;
  border-left: 3px solid rgba(255, 255, 255, 0.78);
  background: linear-gradient( 333deg, #A1B7FF 0%, #B7DAFF 100%);
  transform: skewX(-9deg);
  transition: background 0.45s ease, border-color 0.45s ease;
}

.recommend-shell.task-mode::after {
  left: -72px;
  right: auto;
  background: linear-gradient( 320deg, #F0E5FF 0%, #D4CCFF 100%);
  border-left: 0;
  border-right: 3px solid rgba(255, 255, 255, 0.92);
  transform: skewX(9deg);
}

.recommend-panel {
  position: relative;
  z-index: 1;
  min-height: 610px;
}

.recommend-mode {
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 0;
  margin-left: 85px;
  margin-top: 18px;
  cursor: pointer;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 700;
  font-size: 24px;
  color: #1E293B;
  line-height: 30px;
  transition: color 0.3s ease;
}

.recommend-mode img {
  width: 18px;
  height: 22px;
}

.recommend-tip2 {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 16px;
  color: #56577B;
  line-height: 26px;
  text-align: left;
  width: auto;
  margin: 14px 0 0 85px;
  transition: color 0.3s ease, opacity 0.3s ease;
}

.recommend-viewport {
  position: relative;
  width: 962px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 135px;
}

.recommend-list-track {
  display: flex;
  gap: 22px;
  width: max-content;
}

.task-list-track {
  display: flex;
      width: 100%;
      justify-content: space-between;
}

.recommend-fade-enter-active,
.recommend-fade-leave-active {
  transition: opacity 0.28s ease, transform 0.32s ease;
}

.recommend-fade-enter,
.recommend-fade-leave-to {
  opacity: 0;
  transform: translateY(18px);
}

.anchor-item {
  flex: 0 0 auto;
  width: 308px;
  height: 280px;
  background: url('../../assets/img/zbbg.png') center / 100% 100% no-repeat;
}

.anchor-image-wrap {
  height: 176px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-top: -52px;
}

.anchor-image {
  width: 187px;
}

.anchor-info {
  width: 242px;
  height: 142px;
  margin: -19px auto 0;
  padding: 16px 28px 14px;
  border-radius: 14px;
  background: url('../../assets/img/矩形 74.png') center / 100% 100% no-repeat;
  text-align: center;
}

.anchor-name {
  font-size: 18px;
  font-weight: 700;
}

.anchor-tag {
  width: 74px;
  height: 26px;
  margin: 12px auto 0;
  border-radius: 13px;
  font-size: 12px;
  line-height: 26px;
  color: #6668d7;
  background: rgba(123, 127, 249, 0.12);
}

.anchor-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #8087A4;
  line-height: 17px;
}
.anchor-num span{
	color: #1E293B;
}
.tag1{
	background: rgba(38,132,246,0.2);
	border-radius: 50px 50px 50px 50px;
	border: 1px solid rgba(38,132,246,0.7);
	font-family: Source Han Sans, Source Han Sans;
	font-weight: 500;
	font-size: 12px;
	color: #2684F6;
}

.task-item {
  flex: 0 0 auto;
  width: 278px;
  min-height: 282px;
  padding: 42px 24px 0  44px;
  transition: transform 0.28s ease, box-shadow 0.28s ease, background 0.28s ease;
  margin-top: 103px;
}

.task-item:hover,
.anchor-item:hover {
  transform: translateY(-4px);
}

.task-item-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.task-tag {
  min-width: 60px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  border: 1px solid #8BC0FF;
  background: rgba(238, 251, 255, 0.95);
  font-size: 12px;
  line-height: 26px;
  text-align: center;
  color: #4FA2E8;
}

.task-corner {
  width: 100px;
  height: 86px;
  object-fit: contain;
  margin-top: -63px;
}

.task-title {
  margin-top: 14px;
  font-size: 18px;
  line-height: 26px;
  font-weight: 700;
  color: #2B3147;
}

.task-price {
  margin-top: 12px;
  font-size: 15px;
  color: #4F587E;
}

.task-desc {
  margin-top: 14px;
  color: #8991B1;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 14px;
  color: #8087A4;
  line-height: 24px;
  text-align: left;
  padding-right: 20px;
}

.recommend-expand-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 34px;
      position: absolute;
    right: -13%;
      bottom: 0px;
}

.recommend-expand {
  border: 0;
  background: transparent;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #F6F8FF;
  font-size: 14px;
  line-height: 28px;
  cursor: pointer;
  position: relative;
  z-index: 2;
  margin-right: 56px;
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.task{
	right: 1%;
}

.recommend-expand:hover {
  transform: translateX(-2px);
}

.recommend-shell.task-mode .recommend-mode,
.recommend-shell.task-mode .recommend-tip2 {
  color: #203a72;
}

.recommend-shell.task-mode .recommend-mode,
.recommend-shell.task-mode .recommend-tip2 {
  margin-left: 85px;
}

.recommend-shell.task-mode .recommend-viewport {
  margin-top: 28px;
}

.recommend-shell.task-mode .recommend-expand-row {
  justify-content: flex-start;
}

.recommend-shell.task-mode .recommend-expand {
  margin-left: -109px;
  margin-right: 0;
}

.recommend-shell.task-mode .task-item {
  flex: 0 0 auto;
  width: 308px;
  height: 280px;
  background: url('../../assets/img/jxbg.png') center / 100% 100% no-repeat;
}

.recommend-shell.task-mode .task-tag {
  border-color: #99b9ff;
  background: rgba(244, 249, 255, 0.98);
  color: #5d78d8;
}

.recommend-expand img {
  width: 28px;
  height: 28px;
}

.support-grid {
  display: grid;
  grid-template-columns: 402px 492px;
  gap: 24px;
  width: 1170px;
  margin: 0 auto;
  margin-top: 76px;
}

.support-large,
.support-small {
  overflow: hidden;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(118, 124, 240, 0.1);
}
.support-large .support-large-body{
	margin-top: 25px;
}

.support-large .support-large-body h3{
  /* 设置渐变背景（从左到右）*/
  text-transform: none;
  background: linear-gradient(180deg, #484CED 15%, #C257E5 100%);  /* 将背景裁剪为文字形状 */  -webkit-background-clip: text;  background-clip: text;  /* 隐藏原始文字颜色（显示渐变色） */  color: transparent;  /* 可选：添加字体样式增强效果 */  font-size: 22px;  font-weight: 700;  line-height: 28px;
}

.support-large-image {
  width: 100%;
  display: block;
}

.support-large-body {
  padding: 0px 28px;
}

.support-right {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  width: 744px;
  gap: 22px;
}

.support-small-wide {
  grid-column: 1 / span 2;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
}
.support-small-image2{
	width: 360px;
	height: 192px;
}
.support-small-image {
  width: 526px;
  display: block;
}

.support-small-wide .support-small-image {
  order: 2;
  height: 100%;
  object-fit: cover;
}

.support-small-wide .support-small-body {
  order: 1;
  padding: 22px 28px;
}

.support-small-body {
  padding: 0px 28px;
  margin-bottom: 18px;
}

.finance-list {
	width: 1170px;
	margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: start;
	gap:90px;
  margin-top: 80px;
}

.finance-card {
  width: 342px;
  height: 340px;
  border-radius: 20px 20px 20px 20px;
  background-image: url('../../assets/img/kp.png');
       padding: 44px 25px 44px 46px;
}

.finance-icon-box {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.finance-icon-box img {
  width: 70px;
  height: 70px;
}
.finance-card h3{
	margin-top: 30px !important;
}
.finance-card p{
	margin-top: 20px !important;
	font-family: Source Han Sans, Source Han Sans;
	font-weight: 400;
	font-size: 14px;
	color: #717792;
	line-height: 24px;
	text-align: left;
}
.finance-center {
  padding-top: 14px;
  text-align: center;
}

.finance-center img {
  width: 200px;
}

.finance-actions {
  display: flex;
  gap: 19px;
  margin-top: 26px;
  flex-wrap: wrap;
}


.small-tag {
  height: 28px;
  background: rgba(91,99,243,0.2);
  border-radius: 50px 50px 50px 50px;
  border: 1px solid rgba(91,99,243,0.6);
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 500;
  font-size: 12px;
  color: #5B63F3;
  line-height: 28px;
  text-align: center;
  padding: 0 15px;
}



.assets-bg {
	height: 700px;
	background-image:url('../../assets/img/asbg.png');
	background-size: cover;
}
.assets-bg .section-title-wrap{
	padding-top: 86px;
}
.asset-list {
  display: flex;
  justify-content: center;
  gap: 28px;
  margin-top: 80px;
}

.asset-item {
  position: relative;
  width: 270px;
  height: 304px;
  background: #FFFFFF;
  box-shadow: 2px 2px 10px 0px rgba(164,177,238,0.3), 0px 0px 1px 0px rgba(0,0,0,0.08);
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #E2E8F0;
  cursor: pointer;
}
.asset-item:hover{
	background: linear-gradient( 138deg, #E4F0FF 0%, #FFFFFF 89.15%);
	box-shadow: 2px 2px 10px 0px rgba(164,177,238,0.3), 0px 0px 1px 0px rgba(0,0,0,0.08);
	border-radius: 20px 20px 20px 20px;
	border: 1px solid #7195F6;
}

.asset-card-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.asset-body {
  position: relative;
  z-index: 1;
  padding: 49px 36px 0;
  text-align: center;
}
.asset-body h3{
	font-family: Source Han Sans, Source Han Sans;
	font-weight: 700;
	font-size: 18px;
	color: #1E293B;
	line-height: 28px;
}
.asset-body p{
	margin-top: 14px;
	font-family: Source Han Sans, Source Han Sans;
	font-weight: 400;
	font-size: 14px;
	color: #8087A4;
	line-height: 23px;
	text-align: center;
}

.asset-item.active .asset-body {
  padding-top: 42px;
}

.asset-icon {
  width: 70px;
  height: 70px;
}

.cta-section {
	height: 444px;
	background: url('../../assets/img/kqbg.png') center / 100% 100% no-repeat;
	    margin-top: 0;
}
.jbtt{
	font-family: Source Han Sans, Source Han Sans;
	font-weight: 700;
	font-size: 22px;
	line-height: 28px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	background: linear-gradient(90deg, #484CED 15%, #C257E5 100%);  /* 将背景裁剪为文字形状 */  -webkit-background-clip: text;  background-clip: text;  /* 隐藏原始文字颜色（显示渐变色） */  color: transparent;  /* 可选：添加字体样式增强效果 */
}

.cta-box {
	
  height: 282px;
  padding-top: 116px;
  text-align: center;
  
}

.cta-box h2 {
  font-family: Lenovo-XiaoxinChaokuGB, Lenovo-XiaoxinChaokuGB;
  font-weight: 400;
  font-size: 42px;
  color: #1E293B;
  line-height: 56px;
  text-align: center;
}

.cta-box h2 span {
 /* 设置渐变背景（从左到右）*/  background: linear-gradient(90deg,#6366F1 15%, #C257E5 100%);  /* 将背景裁剪为文字形状 */  -webkit-background-clip: text;  background-clip: text;  /* 隐藏原始文字颜色（显示渐变色） */  color: transparent;
  margin-left: 10px;
}
	
.finance-section{
	min-height: 624px;
}

.cta-box p {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 16px;
  color: #64748B;
  line-height: 30px;
  text-align: center;
  margin-top: 15px;
}

.cta-btn {
  margin-top: 51px;
  width: 168px;
  height: 56px;
  background: linear-gradient( 135deg, #6366F1 0%, #8B5CF6 100%);
  box-shadow: 0px 4px 14px 0px rgba(99,102,241,0.35);
  border-radius: 12px 12px 12px 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border: none;
}

.qr-code-modal {
  position: fixed;
  inset: 0;
  z-index: 2024;
  background: rgba(24, 27, 56, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code-dialog {
  width: 320px;
  padding: 30px 24px 24px;
  border-radius: 20px;
  background: #fff;
  text-align: center;
}

.qr-img {
  width: 180px;
  height: 180px;
}

.qr-label {
  margin-top: 16px;
  color: #545d8d;
  font-size: 14px;
}

.close-btn {
  width: 110px;
  height: 40px;
  margin-top: 18px;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(180deg, #6c7cff 0%, #7962f1 100%);
  color: #fff;
  cursor: pointer;
}

@media (max-width: 1320px) {
  .hero-container {
    width: 100%;
    padding: 84px 40px 0;
  }

  .support-grid,
  .finance-list,
  .asset-list,
  .recommend-tip2,
  .recommend-viewport {
    width: auto;
    max-width: calc(100vw - 40px);
  }

  .support-grid {
    grid-template-columns: 1fr;
  }

  .support-right {
    grid-template-columns: 1fr 1fr;
  }

  .asset-list,
  .intro-cards,
  .recommend-list-track,
  .task-list-track {
    flex-wrap: wrap;
  }
}

@media (max-width: 900px) {
  .hero-container {
    min-height: auto;
    flex-direction: column;
    gap: 30px;
    padding: 110px 20px 30px;
  }

  .hero-copy {
    width: 100%;
  }

  .hero-world {
    left: 0;
    top: -54px;
    font-size: 42px;
  }

  .hero-title,
  .cta-box h2 {
    font-size: 34px;
  }

  .finance-list,
  .support-right,
  .recommend-viewport {
    width: 100%;
  }

  .recommend-shell {
    padding: 56px 0 24px;
  }

  .recommend-shell::after {
    display: none;
  }

  .recommend-panel {
    min-height: auto;
  }

  .recommend-mode,
  .recommend-tip2 {
    margin-left: 0;
  }

  .support-right,
  .recommend-list-track,
  .task-list-track {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    transform: none;
  }

  .task-item,
  .anchor-item {
    width: 100%;
  }

  .recommend-expand-row {
    justify-content: center;
  }

  .support-right {
    grid-template-columns: 1fr;
  }

  .support-small:last-child {
    grid-column: auto;
  }

  .cta-box {
    height: auto;
    padding: 48px 18px;
    background-size: cover;
  }
}
</style>
